<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header"><h5>Врач и шаблон</h5></div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h5>Врач</h5>
                <select v-model="selected_doctor" class="form-control">
                  <option value="0" disabled>Выберите врача</option>
                  <option v-for="doc in receipt_docs" v-bind:value="doc.id">{{ doc.name }}
                    ({{ doc.specialty }})
                  </option>
                </select>
                <div class="row">
                  <div class="col-md-6">
                    <label for="">Дата</label>
                    <input type="text" class="form-control" name="receipt_date_name"
                           v-validate="'required|min:2|max:255'"
                           data-vv-as="Дата"
                           v-model="receipt_date">
                    <small class="form-text text-danger" v-if="errors.has('receipt_date_name')">
                      {{ errors.first('receipt_date_name') }}
                    </small>
                  </div>
                  <div class="col-md-6">
                    <label for="">Номер первого рецепта</label>
                    <input type="text" class="form-control" name="receipt_number_name"
                           v-validate="'required|numeric|integer'"
                           data-vv-as="номер рецепта"
                           v-model="receipt_number">
                    <small class="form-text text-danger" v-if="errors.has('receipt_number_name')">
                      {{ errors.first('receipt_number_name') }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h5>Шаблон</h5>
                <select v-model="selected_template" class="form-control">
                  <option v-for="doc in receipt_templates" v-bind:value="doc.id">{{ doc.title }}
                  </option>
                </select>
                <div class="form-group">
                  <label for="">Номер накладной для импорта препаратов</label>
                  <input type="text" v-model="importDrugsInvoiceNum" placeholder="Номер накладной" class="form-control">
                  <div class="mt-1 text-right">
                    <LoadingButton
                      title="Импортировать препараты"
                      type="button"
                      :loading="btnImportDrugsLoading"
                      :color="$constants.PRIMARY_COLOR"
                      :onClick="() => importDrugsFromInvoice()"
                      className="btn btn-outline-info btn-xs"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row action_btns">
              <div class="col-md-6">
                <template v-if="generatedTemplates.length">
                  <p>Сгенерированы рецепты:</p>
                  <div class="alert alert-info p-1 mb-1" v-for="g in generatedTemplates">
                    <p>{{ receipt_docs.find((d) => d.id === g.doctor)?.name }}</p>
                    <p>номера рецептов {{ g.number }} - {{ g.lastNumber }} (препаратов:
                      <strong>{{ g.drugsQty }}</strong>)</p>
                  </div>
                </template>
              </div>
              <div class="col-md-6 text-rigth">
                <vue-ladda @click="createReceipt(false)" button-class="btn btn-success"
                           data-style="zoom-in"
                           :loading="submit_form_loading_test">Тестовая печать
                </vue-ladda>
                <vue-ladda @click="createReceipt" button-class="btn btn-info"
                           data-style="zoom-in"
                           :loading="submit_form_loading">Создать рецепт (статистика)
                </vue-ladda>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="flex justify-content-between mb-1">
              <h5>Препарат</h5>
              <div class="text-rigth">
                <p class="mb-0">препаратов: <strong>{{ totalDrugsData.drugs }}</strong></p>
                <p class="mb-0">рецептов: <strong>{{ totalDrugsData.receipts }}</strong></p>
              </div>
            </div>
            <form @submit.prevent="() => addDrug()">
              <div class="flex">
                <div class="flex-grow-1">
                  <DrugSearchNew
                    ref="newDrug"
                    :onSelect="(d) => newDrugAdd(d)"
                    :searchOptions="{'details':true}"
                  />
                </div>
                <div class="flex">
                  <input ref="newQty" required placeholder="Кол." type="number" class="form-control">
                  <button type="submit" class="btn btn-outline-success"><i class="icon-fa icon-fa-plus"/></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div v-if="selected_preps" class="card">
          <div class="card-body">
            <div class="row">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Препарат</th>
                  <th>Безрецептурный (ОТС)</th>
                  <th>Название на латыне</th>
                  <th>Signa</th>
                  <th>Упак./дней</th>
                  <th colspan="2">
                    <div class="flex justify-content-between">
                      <div class="align-self-end">Кол. упаковок</div>
                      <button @click="selected_preps = []" class="btn btn-default" type="button">Удалить все</button>
                    </div>
                  </th>
                  <th></th>
                </tr>
                </thead>
                <tbody v-for="(drug, index) in selected_preps">
                <tr ref="`tr_prep_${drug.id}`" :id="`tr_prep_${drug.id}`">
                  <td>
                    <i @click="openDrugEdit(drug.id)" class="icon-fa icon-fa-edit openEditDrugIcon"/>
                    {{ drug.title }}
                  </td>
                  <td>{{ printPrepReceipt(drug.recipe.no_use.int_value) }}</td>
                  <td>{{ drug.recipe.lt_title && drug.recipe.lt_title.text_value || 'не указано' }}</td>
                  <td>{{ drug.recipe.signa && drug.recipe.signa.text_value || 'не указано' }}</td>
                  <td>
                    <template v-if="drug.editFormula">
                      <div>
                        <div class="input-group">
                          <input type="number" v-model="drug.recipe.pack.int_value" class="form-control">
                          <div class="input-group-prepend input-group-append">
                            <span class="input-group-text">/</span>
                          </div>
                          <input v-model="drug.recipe.days.int_value" type="number" class="form-control">
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="flex align-items-center">
                        <span>{{ drug.recipe.pack.int_value }} / {{ drug.recipe.days.int_value }}</span>
                        <button @click="drug.editFormula = true" class="btn btn-default ml-2">
                          <i class="icon-fa icon-fa-edit"/>
                        </button>
                      </div>
                    </template>
                  </td>
                  <td>
                    <div v-if="!drug.recipe.no_use.int_value">
                      <input type="text" class="form-control" :name="`req_qnty_${drug.id}`"
                             placeholder="Кол. упаковок"
                             v-validate="'required|integer|integer|max_value:9000|max:4'"
                             data-vv-as="Кол. упаковок"
                             v-model="requested_qnty[drug.id]">
                      <small class="form-text text-danger"
                             v-if="errors.has(`req_qnty_${drug.id}`)">
                        {{ errors.first(`req_qnty_${drug.id}`) }}
                      </small>
                    </div>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-danger" @click="removePrep(drug.id)">x</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as _ from 'lodash';
import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import store from "@/store";
import LoadingButton from "@/components/buttons/LoadingButton";
import moment from 'moment';

export default {
  components: {
    vSelect,
    VueLadda,
    DrugSearchNew,
    LoadingButton,
  },
  data() {
    return {
      btnImportDrugsLoading: false,
      importDrugsInvoiceNum: null,
      totalDrugsData: {
        drugs: 0,
        receipts: 0
      },
      textN: '',
      submit_form_loading: false,
      submit_form_loading_test: false,
      selected_doctor: 0,
      options: [],
      selected_prep: null,
      selected_preps: [],
      requested_qnty: {},
      selectedPrep: null,
      receipt_docs: null,
      selected_template: null,
      receipt_templates: [],
      receipt_date: null,
      receipt_quantity: null,
      receipt_number: null,
      generatedTemplates: [],
    }
  },
  mounted() {
    this.getDoctors();

    let d = new Date();
    this.receipt_date = ("0" + d.getDate()).slice(-2) + "." + ("0" + (d.getMonth() + 1)).slice(-2) + "." + d.getFullYear()
  },
  watch: {
    selected_preps: {
      handler(e) {
        this.updateTotalFigures();
      },
      deep: true
    },
    requested_qnty: {
      handler(e) {
        this.updateTotalFigures();
      },
      deep: true
    },
  },
  methods: {
    clearSelected() {
      this.receipt_number = '';
      this.selected_doctor = 0;
    },
    async importDrugsFromInvoice() {
      if (!this.importDrugsInvoiceNum) return;
      this.btnImportDrugsLoading = true;
      const {data} = await api.index('/new/drugs/fromInvoice/' + this.importDrugsInvoiceNum);
      if (data.success) {
        const invoiceDetails = data.invoiceDetails.reduce((acc, r) => {
          acc[r.drug_id] = r;
          return acc;
        }, {})
        data.records.forEach((r) => {
          this.addDrug(r, +invoiceDetails[r.id].qty);
        });
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnImportDrugsLoading = false;
    },
    updateTotalFigures() {
      this.totalDrugsData.drugs = Object.values(this.requested_qnty).reduce((acc, d) => acc + +d, 0);
      this.totalDrugsData.receipts = this.selected_preps.reduce((acc, d) => {
        acc += Math.ceil(+(+this.requested_qnty[d.id] || 0) / +(d.recipe.pack && d.recipe.pack.int_value || 1));
        return acc;
      }, 0);
    },
    openDrugEdit(drugId) {
      store.dispatch('modals/setSideData', {drugId: drugId, type: 'editDrug'})
    },
    newDrugAdd(d) {
      if (d) {
        setTimeout(() => {
          this.$refs.newQty.focus();
        }, 100)
      }
    },
    addDrug(drug = null, qty = null) {
      if (!drug) drug = this.$refs.newDrug.drug;
      if (!drug) return;
      // this.selected_preps[drug.id] = {
      if (this.selected_preps.find((d) => d.id === drug.id)) {
        toastr['warning']('Препарат уже в списке', 'Ошибка!')
        return;
      }

      const selectedDrug = {
        ...drug,
        editFormula: false,
        recipe: drug.details.reduce((acc, d) => {
          if (d.group_alias === 'recipe') {
            acc[d.alias] = {...d}
          }
          return acc;
        }, {})
      };

      if (!selectedDrug.recipe || !selectedDrug.recipe.no_use || selectedDrug.recipe.no_use.int_value) {
        toastr['warning'](selectedDrug.title + ' не имеет активного рецепта', 'Внимание!')
        selectedDrug.recipe = {
          pack: {int_value: 0},
          no_use: {int_value: 1},
          lt_title: {text_value: null},
          signa: {text_value: null},
        }
      } else {
        this.selected_preps.push(selectedDrug);
        this.selected_preps = [...this.selected_preps];
        this.requested_qnty[drug.id] = qty || this.$refs.newQty.value;
        this.requested_qnty = {...this.requested_qnty};
      }
      this.$refs.newQty.value = null;
      this.$refs.newDrug.drug = null;
      // this.updateTotalFigures();
    },
    removePrep(id) {
      this.selected_preps = this.selected_preps.filter((d) => d.id !== id);
      this.$delete(this.requested_qnty, id);
      // this.updateTotalFigures();
      // this.$delete(this.selected_preps, id)
    },
    printPrepReceipt(int) {
      return int ? 'без рецепта' : 'по рецепту'
    },
    update(field, e) {
      this.$v[field].$touch()
      dispatch('updateField', field, e.target.value.trim())
    },
    async createReceipt(statistic = true) {

      const valid = await this.$validator.validateAll()
      if (!valid) return

      if (!this.selected_preps.length) {
        toastr['warning']('Нет препаратов для печати', 'Ошибка!')
        return
      }

      if (statistic)
        this.submit_form_loading = true
      else
        this.submit_form_loading_test = true

      const selectedDrugs = this.selected_preps.reduce((acc, d) => {
        acc[d.id] = d;
        return acc;
      }, {});

      const {data} = await api.store('/receipts/createReceipt', {
        doctor: this.selected_doctor,
        drugs: selectedDrugs,
        template: this.selected_template,
        date: this.receipt_date,
        requested_qnty: this.requested_qnty,
        number: this.receipt_number,
        statistic: statistic
      });
      this.submit_form_loading = false
      this.submit_form_loading_test = false
      if (data.success) {
        this.downloadTemplate()
        this.generatedTemplates.push({
          doctor: this.selected_doctor,
          template: this.selected_template,
          drugsQty: Object.keys(selectedDrugs).length,
          number: this.receipt_number,
          lastNumber: data.lastNumber,
        })
        this.clearSelected();
      }
    },
    async getDoctors() {
      const {data} = await api.index('/getReceiptDoctors');
      let doctors_list = [];
      let receipt_list = [];
      let selected_doctor = 0;
      let selected_document = 0;

      let keys = Object.keys(data.doctors)
      keys.forEach((key) => {
        doctors_list.push({
          id: data.doctors[key].id,
          name: data.doctors[key].name,
          specialty: data.doctors[key].specialty
        })
        // if (data.doctors[key].use_default) selected_doctor = key
      })
      keys = Object.keys(data.templates)
      keys.forEach((key) => {
        receipt_list.push({id: data.templates[key].id, title: data.templates[key].title})
        if (data.templates[key].use_default) selected_document = key
      })
      this.receipt_docs = doctors_list
      this.receipt_templates = receipt_list

      // this.selected_doctor = this.receipt_docs[selected_doctor].id
      this.selected_template = this.receipt_templates[selected_document].id

    },

    onSearch(search, loading) {
      if (!search || search.length < 3) return;
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      fetch(
        `/api/v1/getPrepWr?search=${encodeURIComponent(search)}`
      ).then(res => {
        res.json().then(json => (vm.options = json.items));
        loading(false);
      });
    }, 350),
    downloadTemplate() {

      axios({
        url: process.env.MIX_BASE_URL_PREFIX + 'downloadTemplate?template=print',
        method: 'GET',
        headers: {'Cache-Control': 'no-cache', 'Api-Token': localStorage['api-token']},
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'print_' + moment().unix() + '.docx'); //or any other extension
        document.body.appendChild(link);
        link.click();
      });

    }
    ,
  }
}

</script>

<style scoped>
.openEditDrugIcon {
  color: white;
  background-color: #5bbfde;
  padding: 3px 4px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
  text-align: center;
}

.text-rigth {
  text-align: right;
  padding-top: 15px;
}

.btn.ladda-button {
  padding: 2px 17px;
}

.btn-info.ladda-button {
  background-color: #5BBFDE;
}

.btn-success.ladda-button {
  background-color: #4fc47f;
}

input {
  border: 1px solid silver;
  border-radius: 4px;
  background: white;
  padding: 5px 10px;
}

.dirty {
  border-color: #5A5;
  background: #EFE;
}

.dirty:focus {
  outline-color: #8E8;
}

.error {
  border-color: red;
  background: #FDD;
}

.error:focus {
  outline-color: #F99;
}

.action_btns {
  margin-top: 20px;
}

</style>
